import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const links = [
  { label: "Mission", href: "#mission" },
  { label: "Services", href: "#services" },
  { label: "The Gap", href: "#gap" },
  { label: "Impact", href: "#impact" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#F4F1EA]/80 backdrop-blur-xl border-b border-[#1A1A1A]/10" : "border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => goTo(e, "#top")}
          data-testid="logo"
          className="flex items-center gap-2 group"
        >
          <span className="font-serif-display text-2xl md:text-[28px] font-medium tracking-tight text-[#1A1A1A]">
            Independence Way
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-[#C85A3C] mt-1">
            Supportive Living
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => goTo(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="link-underline text-sm uppercase tracking-[0.15em] text-[#1A1A1A]/70 hover:text-[#1A1A1A] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#donate"
          onClick={(e) => goTo(e, "#donate")}
          data-testid="nav-donate-btn"
          className="group inline-flex items-center gap-2 bg-[#C85A3C] text-[#F4F1EA] rounded-full pl-5 pr-4 py-2.5 text-sm uppercase tracking-[0.15em] hover:scale-105 transition-transform duration-300"
        >
          Donate
          <Heart size={15} className="fill-current transition-transform duration-300 group-hover:scale-125" />
        </a>
      </nav>
    </motion.header>
  );
};

export default Navbar;
